import { StylesConfig } from 'react-select';
import Colors from '@domain/constant/colors';

export const ReactSelectStyles: StylesConfig<Record<string, any>, true> = {
  control: () => ({
    position: 'relative',
  }),
  valueContainer: () => ({
    position: 'relative',

    input: {
      position: 'absolute',
      top: 0,
      left: 0,
    },
  }),
  singleValue: (base: any, state: any) => ({
    display: 'block',
    padding: '0 32px 0 16px',
  }),
  indicatorsContainer: () => ({
    display: 'none',
  }),
  menu: () => ({
    overflow: 'hidden',
    position: 'absolute',
    right: -1,
    bottom: 0,
    left: -1,
    border: `1px solid ${Colors.C_COOL_GRAY_40}`,
    borderTopWidth: 0,
    borderRadius: '0 0 16px 16px',
    backgroundColor: Colors.C_WHITE,
    transform: 'translateY(100%)',

    ':before': {
      position: 'absolute',
      top: 0,
      right: 8,
      left: 8,
      height: 1,
      backgroundColor: Colors.C_COOL_GRAY_40,
      content: `''`,
    },
  }),
  menuList: () => ({
    padding: '3px 0 8px',
  }),
  option: (base: any, state: any) => ({
    position: 'relative',
    marginTop: 1,
    padding: '0 16px 0 20px',
    fontSize: 15,
    fontWeight: state.isSelected ? 700 : 400,
    lineHeight: '44px',
    letterSpacing: -0.36,
    color: Colors.C_COOL_GRAY_90,
    textAlign: 'left',

    ':hover': {
      backgroundColor: Colors.C_JOBDA_WHITE,
      color: Colors.C_COOL_GRAY_70,
    },

    ':after': {
      position: 'absolute',
      top: 14,
      right: 16,
      width: 16,
      height: 16,
      backgroundImage: state.isSelected && `url('/img/components/dropDown/iconCheck.png')`,
      backgroundSize: 'cover',
      content: `''`,
    },
  }),
};
